/* global React */
// AtelierChat — bilingual (EN/FA) Nazarban consultation chat.
// Talks to /api/chat and /api/collect-email; falls back to a local reply offline.

const NZ_MARK = (
  <svg viewBox="-4 -4 506.9 400.31" fill="none" aria-hidden="true">
    <path d="M299.7 299.66L163.97 104.37L163.97 275.06C163.97 288.9 169.31 296.6 179.97 298.18L179.97 299.66L145.3 299.66L145.3 298.18C155.97 296.8 161.3 289.1 161.3 275.06L161.3 116.82C161.3 102.79 155.97 95.09 145.3 93.7L145.3 92.22L180.57 92.22L299.7 265.88L302.37 269.73L322.81 299.66Z" fill="currentColor"/>
    <path d="M330.48 299.66L197.19 107.88C194.15 103.51 190.28 99.72 185.66 97.08C182.9 95.5 179.64 94.16 176.08 93.7L176.08 92.22L211.35 92.22L333.14 269.73L353.59 299.66Z" fill="currentColor"/>
    <path d="M164.13 114.39L164.13 124.56L285.55 300.08L292.33 300.08Z" fill="currentColor"/>
    <path d="M327.29 116.82L327.29 264.36L329.96 264.36L329.96 116.82C329.96 102.79 335.29 95.08 345.96 93.7L345.96 92.22L311.29 92.22L311.29 93.7C321.96 95.28 327.29 102.99 327.29 116.82" fill="currentColor"/>
  </svg>
);

const I = {
  flow:  <svg viewBox="0 0 24 24" fill="none"><circle cx="6" cy="6" r="2.3" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="6" r="2.3" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="18" r="2.3" stroke="currentColor" strokeWidth="1.5"/><path d="M8 7.6l3 8M16 7.6l-3 8" stroke="currentColor" strokeWidth="1.5"/></svg>,
  bot:   <svg viewBox="0 0 24 24" fill="none"><rect x="4.5" y="8.5" width="15" height="10.5" rx="2.5" stroke="currentColor" strokeWidth="1.5"/><path d="M12 4.5v4M9.3 13.2h.01M14.7 13.2h.01" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>,
  doc:   <svg viewBox="0 0 24 24" fill="none"><path d="M7 3.5h7l4 4v13H7z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M14 3.5v4h4M10 13h5M10 16h5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  chart: <svg viewBox="0 0 24 24" fill="none"><path d="M4 19.5V5M4 19.5h16M8 16v-3.5M12 16V8.5M16 16v-6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></svg>,
  send:  <svg viewBox="0 0 24 24" fill="none"><path d="M4 11.5l15.5-7-7 15.5-2-6.2-6.5-2.3z" fill="currentColor"/></svg>,
  arrow: <svg viewBox="0 0 24 24" fill="none"><path d="M5 12h13M12.5 5.5L19 12l-6.5 6.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  doc2:  <svg viewBox="0 0 24 24" fill="none"><path d="M7 3.5h7l4 4v13H7z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round"/><path d="M14 3.5v4h4M10 13h5M10 16.5h5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>,
  x:     <svg viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  check: <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  mail:  <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5.5" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.6"/><path d="M4 7.5l8 5.5 8-5.5" stroke="currentColor" strokeWidth="1.6"/></svg>,
  phone: <svg viewBox="0 0 24 24" fill="none"><path d="M6 3.5h3l1.4 4.6-1.9 1.4a12 12 0 005.6 5.6l1.4-1.9 4.6 1.4v3a1.8 1.8 0 01-1.9 1.8A16 16 0 014.2 5.4 1.8 1.8 0 016 3.5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>,
  mic:   <svg viewBox="0 0 24 24" fill="none"><rect x="9" y="3" width="6" height="11" rx="3" stroke="currentColor" strokeWidth="1.7"/><path d="M5.5 11.5a6.5 6.5 0 0013 0M12 18v3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>,
  hangup: <svg viewBox="0 0 24 24" fill="none"><path d="M4.2 14.8c-1.6-1.6-1.5-3.5.2-4.6a14.7 14.7 0 0115.2 0c1.7 1.1 1.8 3 .2 4.6l-.9.9c-.6.6-1.6.7-2.3.2l-1.9-1.4c-.6-.4-.9-1.1-.8-1.8l.1-.9a11 11 0 00-4 0l.1.9c.1.7-.2 1.4-.8 1.8l-1.9 1.4c-.7.5-1.7.4-2.3-.2z" fill="currentColor"/></svg>,
};

const PROMPT_ICONS = [I.flow, I.bot, I.doc, I.chart];

// --- bilingual strings ---
const T = {
  en: {
    consultant: 'AI Consultant', online: 'Online', getProposal: 'Get a proposal',
    welcomeEyebrow: 'Consultation',
    welcomeH2: <>Let us scope your <em>intelligent</em> solution.</>,
    welcomeP: "Describe a process, a constraint, or an ambition. We translate it into a secure, working system — quietly, and well.",
    prompts: ['Automate a manual workflow', 'Build a custom AI assistant', 'Process documents at scale', 'Forecast demand from our data'],
    inputPh: "Describe a process you'd like to automate…",
    propH3: 'Get your free AI proposal',
    propSub: "We'll review what you've described and send a tailored, no-obligation proposal—scope, timeline, and a path to a 14-day pilot—within 24 hours.",
    emailPh: 'your@email.com', send: 'Send it', sending: 'Sending…',
    sendError: "Something went wrong and your request didn't go through — please try again.",
    propFine: 'A summary of this chat is included',
    noChatH3: 'Chat with us first',
    noChatSub: 'Tell us about your project so we can tailor your proposal — even a sentence helps.',
    startChatting: 'Start chatting',
    sentH3: 'Proposal on its way.',
    sentSub: (e) => <>Thank you—we'll be in touch at <strong>{e}</strong> within 24 hours with a tailored proposal. You can keep the conversation going in the meantime.</>,
    backToChat: 'Back to chat',
    farewell: "Thank you — we'll be in touch shortly with next steps.",
    fallback: "Noted. The fastest way to know if this is worth it is a scoped proof-of-concept against your own data. Tell me the process, the volume, and what 'good' looks like — and I'll map the path to a working pilot.",
    voiceStart: 'Prefer to talk? Start a voice call',
    voiceConnecting: 'Connecting…',
    voiceListening: 'Listening — go ahead',
    voiceSpeaking: 'Consultant speaking…',
    voiceEnd: 'End call',
    voiceUnavailable: 'The voice line is briefly unavailable — please try again in a moment, or keep typing here.',
    micDenied: "I couldn't access your microphone. Please allow microphone access in your browser and try the call again — or simply keep typing here.",
    waTitle: 'Continue on WhatsApp',
    waBody: "Tap below to reach the team directly — a short intro from this conversation is included, so you won't have to repeat yourself.",
    waButton: 'Open WhatsApp',
    productsTitle: 'From the Nazarban product line',
    productsMore: 'See all products',
    benchTitle: 'LLM benchmark — top models',
    benchMore: 'Full leaderboard',
  },
  fa: {
    consultant: 'مشاور هوش مصنوعی', online: 'آنلاین', getProposal: 'دریافت پیشنهاد',
    welcomeEyebrow: 'مشاوره',
    welcomeH2: <>بیایید <em>راه‌حل هوشمند</em> شما را ترسیم کنیم.</>,
    welcomeP: 'یک فرآیند، محدودیت یا هدف را برایمان توصیف کنید. آن را به سیستمی امن و کاربردی تبدیل می‌کنیم — بی‌سروصدا و با دقت.',
    prompts: ['خودکارسازی یک گردش کار دستی', 'ساخت یک دستیار هوش مصنوعی اختصاصی', 'پردازش اسناد در مقیاس بزرگ', 'پیش‌بینی تقاضا از داده‌های ما'],
    inputPh: 'فرآیندی را که می‌خواهید خودکار کنید توصیف کنید…',
    propH3: 'پیشنهاد رایگان هوش مصنوعی خود را دریافت کنید',
    propSub: 'آنچه را توصیف کرده‌اید بررسی می‌کنیم و ظرف 24 ساعت یک پیشنهاد اختصاصی و بدون تعهد — با محدوده، زمان‌بندی و مسیری به سمت یک نمونه اولیه 14 روزه — برایتان ارسال می‌کنیم.',
    emailPh: 'ایمیل شما', send: 'ارسال', sending: 'در حال ارسال…',
    sendError: 'مشکلی پیش آمد و درخواست شما ارسال نشد — لطفاً دوباره امتحان کنید.',
    propFine: 'خلاصه‌ای از این گفتگو نیز پیوست می‌شود',
    noChatH3: 'ابتدا با ما چت کنید',
    noChatSub: 'درباره پروژه‌تان به ما بگویید تا پیشنهادتان را متناسب کنیم — حتی یک جمله کافی است.',
    startChatting: 'شروع گفتگو',
    sentH3: 'پیشنهاد در راه است.',
    sentSub: (e) => <>متشکریم — ظرف 24 ساعت از طریق <strong>{e}</strong> با یک پیشنهاد اختصاصی با شما در تماس خواهیم بود. در این فاصله می‌توانید به گفتگو ادامه دهید.</>,
    backToChat: 'بازگشت به گفتگو',
    farewell: 'متشکریم — به‌زودی با گام‌های بعدی در تماس خواهیم بود.',
    fallback: 'متوجه شدم. سریع‌ترین راه برای فهمیدن ارزش این کار، یک نمونه اولیه دقیق روی داده‌های خودتان است. فرآیند، حجم کار و اینکه «موفقیت» برایتان چه معنایی دارد را بگویید تا مسیر رسیدن به یک نمونه اولیه کاربردی را ترسیم کنم.',
    voiceStart: 'ترجیح می‌دهید صحبت کنید؟ یک تماس صوتی شروع کنید',
    voiceConnecting: 'در حال اتصال…',
    voiceListening: 'در حال گوش دادن — بفرمایید',
    voiceSpeaking: 'مشاور در حال صحبت است…',
    voiceEnd: 'پایان تماس',
    voiceUnavailable: 'خط صوتی موقتاً در دسترس نیست — لطفاً چند لحظه دیگر دوباره امتحان کنید، یا همین‌جا تایپ کنید.',
    micDenied: 'دسترسی به میکروفون شما ممکن نشد. لطفاً دسترسی میکروفون را در مرورگرتان مجاز کنید و دوباره تماس بگیرید — یا همین‌جا تایپ کنید.',
    waTitle: 'ادامه در واتساپ',
    waBody: 'برای تماس مستقیم با تیم، پایین را بزنید — یک معرفی کوتاه از این گفتگو هم پیوست شده تا مجبور نباشید دوباره توضیح دهید.',
    waButton: 'باز کردن واتساپ',
    productsTitle: 'از خط محصولات نظربان',
    productsMore: 'مشاهده همه محصولات',
    benchTitle: 'رتبه‌بندی مدل‌های زبانی — برترین مدل‌ها',
    benchMore: 'جدول کامل',
  },
};

// --- live voice call (ElevenLabs Conversational AI) --------------------
// The SDK is self-hosted and loaded lazily, only when a visitor actually
// starts a call — the chat page pays no weight for it otherwise.
const VOICE_SDK_SRC = '/js/vendor/elevenlabs-client.js';
// Self-hosted libsamplerate worklet — used for mic resampling on browsers that
// don't support the getUserMedia sampleRate constraint (Safari, Firefox, iOS).
// Passing an explicit path keeps it off the third-party CDN the SDK defaults to,
// which a strict CSP would otherwise block.
const VOICE_LIBSAMPLERATE_PATH = '/js/vendor/libsamplerate.worklet.js';
let voiceSdkPromise = null;
function loadVoiceSdk() {
  if (window.ElevenLabsClient) return Promise.resolve();
  if (!voiceSdkPromise) {
    voiceSdkPromise = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = VOICE_SDK_SRC;
      s.async = true;
      s.onload = resolve;
      s.onerror = () => { voiceSdkPromise = null; reject(new Error('Voice SDK failed to load')); };
      document.head.appendChild(s);
    });
  }
  return voiceSdkPromise;
}

// Browser autoplay policy starts an AudioContext "suspended", and while it is
// suspended the SDK's mic-capture and playback worklets produce nothing — the
// call connects but no audio flows either way. Resuming a context inside the
// click (a real user gesture, before any await) unlocks audio for the page so
// the SDK's own contexts resume cleanly afterwards. Best-effort; safe to fail.
let voiceAudioPrimed = false;
function primeAudioForVoice() {
  if (voiceAudioPrimed) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const buf = ctx.createBuffer(1, 1, 22050);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    src.start(0);
    const done = () => { ctx.close().catch(() => {}); };
    ctx.resume().then(done, done);
    voiceAudioPrimed = true;
  } catch (e) { /* non-fatal */ }
}

// Agent replies may carry v3 audio tags like "[warmly]" — stage directions
// for the voice, not copy for the eyes. Strip them from the transcript.
function cleanVoiceText(raw) {
  return String(raw == null ? '' : raw).replace(/\[[^\]]*\]/g, ' ').replace(/\s+/g, ' ').trim();
}

// --- live page actions (ElevenLabs client tools) ------------------------
// During a call the agent can operate the page: pull product cards or the
// benchmark table into the thread, open the proposal form, hand off to
// WhatsApp, scroll to a section, or flip the site language. Each handler
// returns a short string — that text is sent back to the agent, so it
// narrates what actually happened instead of guessing. Definitions on the
// agent side are managed by scripts/sync-voice-agent.js.
const SECTION_TARGETS = {
  what_we_do: '[data-screen-label="What we do"]',
  explore: '[data-screen-label="Explore Nazarban"]',
  contact: 'footer.footer',
  chat: '#consult',
  top: '.hero.chat-intro',
};
const WHATSAPP_NUMBER = '19165870145';
const WHATSAPP_NUMBER_FA = '989120437502';
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function spotlight(el) {
  el.classList.remove('nz-spotlight');
  void el.offsetWidth; // restart the animation on repeat calls
  el.classList.add('nz-spotlight');
  setTimeout(() => el.classList.remove('nz-spotlight'), 2600);
}

const now = () => {
  const d = new Date();
  return d.getHours().toString().padStart(2, '0') + ':' + d.getMinutes().toString().padStart(2, '0');
};

// Rich cards the tools drop into the thread, styled like bot bubbles.
function WhatsCard({ href, t }) {
  return (
    <div className="chat-bubble chat-card">
      <div className="cc-head">{I.phone}<strong>{t.waTitle}</strong></div>
      <p className="cc-sub">{t.waBody}</p>
      <a className="cc-btn" href={href} target="_blank" rel="noopener">{t.waButton} {I.arrow}</a>
    </div>
  );
}

function ProductsCard({ items, t }) {
  return (
    <div className="chat-bubble chat-card">
      <div className="cc-head">{I.chart}<strong>{t.productsTitle}</strong></div>
      <div className="cc-grid">
        {items.map((p) => (
          <a className="cc-item" key={p.id} href={'/product-detail?id=' + encodeURIComponent(p.id)} target="_blank" rel="noopener">
            <strong>{p.name}</strong>
            <span>{p.tagline}</span>
          </a>
        ))}
      </div>
      <a className="cc-more" href="/products" target="_blank" rel="noopener">{t.productsMore} {I.arrow}</a>
    </div>
  );
}

function BenchCard({ rows, t }) {
  return (
    <div className="chat-bubble chat-card">
      <div className="cc-head">{I.chart}<strong>{t.benchTitle}</strong></div>
      <table>
        <tbody>
          {rows.map((r) => (
            <tr key={r.rank}><td>#{r.rank}</td><td>{r.name}</td><td>{r.score != null ? r.score : ''}</td></tr>
          ))}
        </tbody>
      </table>
      <a className="cc-more" href="/benchmark" target="_blank" rel="noopener">{t.benchMore} {I.arrow}</a>
    </div>
  );
}

function useLang() {
  const [lang, setLang] = React.useState(window.NZ_LANG ? window.NZ_LANG.get() : 'en');
  React.useEffect(() => {
    const h = (e) => setLang(e.detail.lang);
    document.addEventListener('languagechange', h);
    return () => document.removeEventListener('languagechange', h);
  }, []);
  return lang;
}

function ProposalPopup({ onClose, getConversation, hasConversation, initialEmail }) {
  const lang = useLang();
  const t = T[lang];
  const [email, setEmail] = React.useState(initialEmail || '');
  const [sent, setSent] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [failed, setFailed] = React.useState(false);
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const submit = async (e) => {
    e.preventDefault();
    if (!valid || busy) return;
    setBusy(true);
    setFailed(false);
    try {
      const res = await fetch('/api/collect-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: email.trim(), source: 'popup',
          conversationHistory: (getConversation && getConversation()) || [],
          language: lang,
        }),
      });
      if (!res.ok) throw new Error('collect-email failed: ' + res.status);
      setSent(true);
    } catch (err) {
      console.error('Failed to save email:', err);
      setFailed(true);
    }
    setBusy(false);
  };

  return (
    <div className="prop-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="prop-card" role="dialog" aria-modal="true">
        <button className="x" aria-label="Close" onClick={onClose}>{I.x}</button>
        {!hasConversation ? (
          <div className="prop-no-chat">
            <span className="seal">{I.doc2}</span>
            <h3>{t.noChatH3}</h3>
            <p className="sub">{t.noChatSub}</p>
            <button className="btn btn-solid btn-sm" type="button" onClick={onClose} style={{ marginTop: 4 }}>{t.startChatting} {I.arrow}</button>
          </div>
        ) : !sent ? (
          <React.Fragment>
            <span className="seal">{I.doc2}</span>
            <h3>{t.propH3}</h3>
            <p className="sub">{t.propSub}</p>
            <form className="prop-field" onSubmit={submit}>
              <input type="email" value={email} placeholder={t.emailPh}
                onChange={(e) => setEmail(e.target.value)} autoFocus />
              <button type="submit" disabled={!valid || busy}>{busy ? t.sending : t.send} {I.arrow}</button>
            </form>
            {failed && <p className="prop-error">{t.sendError}</p>}
            <p className="prop-fine">{t.propFine}</p>
          </React.Fragment>
        ) : (
          <div className="prop-success">
            <span className="check">{I.check}</span>
            <h3>{t.sentH3}</h3>
            <p className="sub">{t.sentSub(email.trim())}</p>
            <button className="btn btn-solid btn-sm" type="button" onClick={onClose} style={{ marginTop: 4 }}>{t.backToChat}</button>
          </div>
        )}
      </div>
    </div>
  );
}

function AtelierChat() {
  const lang = useLang();
  const t = T[lang];
  const [messages, setMessages] = React.useState([]);
  const [input, setInput] = React.useState('');
  const [typing, setTyping] = React.useState(false);
  const [flew, setFlew] = React.useState(false);
  const [showProp, setShowProp] = React.useState(false);
  const [propEmail, setPropEmail] = React.useState(''); // prefill from the voice agent
  const [nudged, setNudged] = React.useState(false);
  const [voiceCfg, setVoiceCfg] = React.useState(null);   // /api/voice/config payload
  const [voiceState, setVoiceState] = React.useState('idle'); // 'idle' | 'connecting' | 'live'
  const [voiceMode, setVoiceMode] = React.useState('listening');
  const scrollRef = React.useRef(null);
  const inputRef = React.useRef(null);
  const timers = React.useRef([]);
  const convo = React.useRef([]);
  const stageRef = React.useRef('initial');
  const emailRef = React.useRef(undefined);
  const voiceRef = React.useRef(null);   // active SDK conversation
  const productsRef = React.useRef(null); // cached /api/products payload
  const langRef = React.useRef(lang);
  langRef.current = lang;

  React.useEffect(() => () => timers.current.forEach(clearTimeout), []);

  // Discover whether the voice consultant is configured; if not, the mic
  // button never renders and the chat is exactly as before.
  React.useEffect(() => {
    let alive = true;
    fetch('/api/voice/config', { headers: { Accept: 'application/json' } })
      .then((r) => r.json())
      .then((d) => {
        if (!alive) return;
        if (d && d.enabled) {
          setVoiceCfg(d);
          // Preload the SDK now so tapping the mic doesn't wait on a download —
          // keeping the gap between the click and audio start-up short.
          loadVoiceSdk().catch(() => {});
        } else {
          setVoiceCfg(null);
        }
      })
      .catch(() => { if (alive) setVoiceCfg(null); });
    return () => {
      alive = false;
      if (voiceRef.current) { voiceRef.current.endSession().catch(() => {}); voiceRef.current = null; }
    };
  }, []);

  React.useEffect(() => {
    const q = new URLSearchParams(window.location.search).get('q');
    if (q) setInput(decodeURIComponent(q));
  }, []);

  // When a visitor arrives via the "Talk to the AI consultant" CTA (/#consult),
  // focus the chat input so it's immediately clear they've landed in the chatbot.
  // preventScroll keeps the browser's anchor scroll (chat clears the sticky nav).
  React.useEffect(() => {
    if (window.location.hash === '#consult' && inputRef.current) {
      const id = setTimeout(() => {
        if (inputRef.current) inputRef.current.focus({ preventScroll: true });
      }, 300);
      timers.current.push(id);
    }
  }, []);

  const userCount = messages.filter((m) => m.who === 'user').length;
  React.useEffect(() => {
    // Voice turns count too, but never interrupt a live call with the popup —
    // it appears once the visitor hangs up.
    if (!nudged && userCount >= 2 && !typing && voiceState === 'idle') {
      const id = setTimeout(() => { setShowProp(true); setNudged(true); }, 900);
      timers.current.push(id);
      return () => clearTimeout(id);
    }
  }, [userCount, typing, nudged, voiceState]);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTop = el.scrollHeight;
  }, [messages, typing]);

  const sendText = (raw) => {
    const text = (raw || '').trim();
    if (!text || typing) return;
    setFlew(true);
    timers.current.push(setTimeout(() => setFlew(false), 420));
    setMessages((m) => [...m, { who: 'user', text, time: now() }]);
    setInput('');
    setTyping(true);
    convo.current.push({ role: 'user', content: text });

    const pushBot = (reply) => {
      setTyping(false);
      setMessages((m) => [...m, { who: 'bot', text: reply, time: now() }]);
      convo.current.push({ role: 'assistant', content: reply });
    };

    fetch('/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: text,
        conversationHistory: convo.current,
        conversationStage: stageRef.current,
        userEmail: emailRef.current,
        language: langRef.current,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.success && data.message) {
          if (data.conversationStage) stageRef.current = data.conversationStage;
          if (data.userEmail) emailRef.current = data.userEmail;
          pushBot(data.message);
          // Site actions chosen by the text model — dispatched through the
          // same handlers the voice agent uses, slightly staggered so the
          // reply lands first and cards follow.
          if (Array.isArray(data.actions)) {
            data.actions.slice(0, 4).forEach((a, idx) => {
              timers.current.push(setTimeout(() => {
                const fn = a && voiceToolsRef.current && voiceToolsRef.current[a.tool];
                if (fn) Promise.resolve(fn(a.args || {})).catch(() => {});
              }, 350 + idx * 450));
            });
          }
          if (data.conversationComplete) {
            timers.current.push(setTimeout(() => {
              setMessages((m) => [...m, { who: 'bot', text: T[langRef.current].farewell, time: now() }]);
            }, 1400));
          }
        } else {
          pushBot((data && data.message) || T[langRef.current].fallback);
        }
      })
      .catch((err) => {
        console.error('Chat error:', err);
        timers.current.push(setTimeout(() => pushBot(T[langRef.current].fallback), 600));
      });
  };

  // --- site actions the voice agent can call ------------------------------
  // Handlers live in a ref so the registry is built once; they read live
  // state through refs and functional setState only.
  const buildChatContext = () => {
    const turns = convo.current.slice(-12);
    if (!turns.length) return '(no prior text chat)';
    const s = turns.map((x) => (x.role === 'user' ? 'Visitor: ' : 'Consultant: ') + x.content).join('\n');
    return s.length > 1600 ? s.slice(-1600) : s;
  };

  const voiceToolsRef = React.useRef(null);
  if (!voiceToolsRef.current) {
    const pushCard = (kind, data) => setMessages((m) => [...m, { who: 'bot', kind, data, time: now() }]);

    voiceToolsRef.current = {
      show_section: ({ section } = {}) => {
        const key = String(section || '').toLowerCase().trim().replace(/[\s-]+/g, '_');
        const sel = SECTION_TARGETS[key];
        if (!sel) return 'Unknown section "' + section + '". Valid sections: ' + Object.keys(SECTION_TARGETS).join(', ') + '.';
        const el = document.querySelector(sel);
        if (!el) return 'That section is not present on this page.';
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        spotlight(el);
        return 'Scrolled the page to the "' + key + '" section — it is highlighted for the visitor now.';
      },

      show_products: async ({ product } = {}) => {
        if (!productsRef.current) {
          const r = await fetch('/api/products', { headers: { Accept: 'application/json' } });
          const d = await r.json();
          productsRef.current = (d && d.products) || [];
        }
        const all = productsRef.current;
        if (!all.length) return 'No products are published right now — describe our services instead.';
        const fa = langRef.current === 'fa';
        let list = all;
        if (product) {
          const q = String(product).toLowerCase();
          const hits = all.filter((p) =>
            ((p.nameEn || '') + ' ' + (p.nameFa || '') + ' ' + (p.taglineEn || '')).toLowerCase().includes(q));
          if (hits.length) list = hits;
        }
        const shown = list.slice(0, 4).map((p) => ({
          id: p.id,
          name: (fa ? p.nameFa : p.nameEn) || p.nameEn || p.nameFa || '',
          tagline: (fa ? p.taglineFa : p.taglineEn) || p.taglineEn || '',
        }));
        pushCard('products', { products: shown });
        return 'Product cards are showing in the chat: '
          + shown.map((p) => p.name + ' — ' + p.tagline).join(' · ')
          + '. Describe them from this data only; full pages open in a new tab.';
      },

      show_benchmarks: async () => {
        try {
          const r = await fetch('/api/benchmark/data', { headers: { Accept: 'application/json' } });
          if (!r.ok) throw new Error('unavailable');
          const d = await r.json();
          let rows = Array.isArray(d) ? d : null;
          if (!rows && d && typeof d === 'object') {
            for (const k of ['data', 'models', 'leaderboard', 'rows', 'entries', 'results']) {
              if (Array.isArray(d[k])) { rows = d[k]; break; }
            }
            if (!rows) rows = Object.values(d).find(Array.isArray) || null;
          }
          const named = (rows || []).map((x) => ({
            name: x.model || x.name || x.model_name || x.id,
            score: [x.score, x.elo, x.rating, x.overall, x.average].find((v) => typeof v === 'number'),
          })).filter((x) => x.name);
          if (!named.length) return 'The live benchmark table is empty right now — point the visitor to the /benchmark page instead.';
          named.sort((a, b) => (b.score || 0) - (a.score || 0));
          const top = named.slice(0, 5).map((x, i) => ({ rank: i + 1, name: String(x.name), score: x.score }));
          pushCard('benchmark', { rows: top });
          return 'Benchmark card is showing. Top models: '
            + top.map((x) => '#' + x.rank + ' ' + x.name + (x.score != null ? ' (' + x.score + ')' : '')).join(', ')
            + '. Full leaderboard opens in a new tab.';
        } catch (e) {
          return 'Benchmark data is unavailable right now — point the visitor to the /benchmark page.';
        }
      },

      open_proposal: ({ email } = {}) => {
        const e = String(email || '').trim();
        const ok = EMAIL_RE.test(e);
        setPropEmail(ok ? e : '');
        setShowProp(true);
        return ok
          ? 'Proposal form is open with ' + e + ' prefilled — ask the visitor to confirm it and tap send.'
          : 'Proposal form is open — ask the visitor to type their email and tap send.';
      },

      contact_human: ({ topic } = {}) => {
        const clean = String(topic || '').slice(0, 140);
        const fa = langRef.current === 'fa';
        const prefill = fa
          ? 'سلام تیم نظربان — همین الان داشتم با مشاور هوش مصنوعی‌تون صحبت می‌کردم' + (clean ? ' درباره: ' + clean : '') + '، و می‌خوام با یکی از اعضای تیم ادامه بدم.'
          : 'Hello Nazarban team — I was just speaking with your AI consultant' + (clean ? ' about: ' + clean : '') + ', and I would like to continue with a human.';
        pushCard('whatsapp', { href: 'https://wa.me/' + (fa ? WHATSAPP_NUMBER_FA : WHATSAPP_NUMBER) + '?text=' + encodeURIComponent(prefill) });
        fetch('/api/voice/lead-alert', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ topic: clean, language: langRef.current, transcript: convo.current.slice(-10) }),
        }).catch(() => {});
        return 'A WhatsApp card is in the chat — tell the visitor to tap it to reach the team directly. The team has also been alerted with the conversation context.';
      },

      switch_language: ({ language } = {}) => {
        const raw = String(language || '').toLowerCase();
        const l = raw.startsWith('fa') || raw.includes('farsi') || raw.includes('persian') ? 'fa' : (raw.startsWith('en') ? 'en' : null);
        if (!l) return 'Unsupported language "' + language + '". Valid values: en, fa.';
        if (window.NZ_LANG) window.NZ_LANG.set(l);
        return 'Site interface switched to ' + (l === 'fa' ? 'Persian (Farsi)' : 'English') + '.';
      },
    };
    // Exposed for debugging and UI tests; harmless in production.
    window.NZ_VOICE_TOOLS = voiceToolsRef.current;
  }

  // --- voice call lifecycle ---------------------------------------------
  // Everything said out loud lands in the same thread and the same
  // conversation history, so a call and the text chat are one conversation:
  // the proposal email includes voice turns, and typing after a call
  // continues with full context.
  const startVoice = async () => {
    if (voiceState !== 'idle' || !voiceCfg) return;
    // Unlock audio synchronously, while we still hold the click's user gesture,
    // BEFORE any await — otherwise the SDK's AudioContext can stay suspended and
    // no audio flows in or out even though the call connects.
    primeAudioForVoice();
    setVoiceState('connecting');
    setVoiceMode('listening');
    try {
      await loadVoiceSdk();

      let session;
      if (voiceCfg.mode === 'public' && voiceCfg.agentId) {
        session = { agentId: voiceCfg.agentId };
      } else {
        // signed mode: mint a fresh short-lived URL right before the call
        const r = await fetch('/api/voice/signed-url', { headers: { Accept: 'application/json' } });
        const d = await r.json();
        if (!d || !d.success || !d.signedUrl) throw new Error('No signed URL');
        session = { signedUrl: d.signedUrl };
      }

      // Per-call diagnostic flags: prove whether the caller's mic audio is
      // registering (VAD) and whether the agent is producing audio.
      let sawUserAudio = false;
      let sawAgentAudio = false;
      const conversation = await window.ElevenLabsClient.Conversation.startSession(
        Object.assign(session, {
          connectionType: 'websocket',
          libsampleratePath: VOICE_LIBSAMPLERATE_PATH,
          // chat_context lets the agent pick up mid-conversation instead of
          // starting cold (referenced as {{chat_context}} in the agent prompt).
          dynamicVariables: { site_language: langRef.current, chat_context: buildChatContext() },
          clientTools: voiceToolsRef.current,
          onMessage: (m) => {
            const role = (m && (m.role || m.source)) || '?';
            console.info('[voice] message:', role, '·', cleanVoiceText(m && m.message).slice(0, 80));
            const text = cleanVoiceText(m && m.message);
            if (!text) return;
            const who = (role === 'user') ? 'user' : 'bot';
            setMessages((x) => [...x, { who, text, time: now() }]);
            convo.current.push({ role: who === 'user' ? 'user' : 'assistant', content: text });
          },
          onAudio: () => { if (!sawAgentAudio) { sawAgentAudio = true; console.info('[voice] receiving agent audio ✓ (agent is speaking)'); } },
          onVadScore: (p) => { if (!sawUserAudio && p && p.vadScore > 0.5) { sawUserAudio = true; console.info('[voice] your mic is registering ✓ (voice detected)'); } },
          onModeChange: (p) => { console.info('[voice] mode:', p && p.mode); setVoiceMode((p && p.mode) || 'listening'); },
          onStatusChange: (p) => {
            const status = p && p.status;
            console.info('[voice] status:', status);
            if (status === 'connected') setVoiceState('live');
            if (status === 'disconnected') { voiceRef.current = null; setVoiceState('idle'); }
          },
          onConnect: (p) => console.info('[voice] connected, conversationId:', p && p.conversationId),
          onDisconnect: (details) => {
            // details.reason is 'user' | 'agent' | 'error'; surface real errors so
            // a failed call doesn't just fall silent.
            console.info('[voice] disconnected:', details);
            if (details && details.reason === 'error') {
              setMessages((x) => [...x, { who: 'bot', text: T[langRef.current].voiceUnavailable, time: now() }]);
            }
          },
          onError: (message, context) => console.error('[voice] error:', message, context || ''),
        })
      );
      voiceRef.current = conversation;
    } catch (err) {
      console.error('[voice] call failed to start:', err);
      voiceRef.current = null;
      setVoiceState('idle');
      const micBlocked = err && (err.name === 'NotAllowedError' || err.name === 'NotFoundError' || err.name === 'NotReadableError');
      const note = micBlocked ? T[langRef.current].micDenied : T[langRef.current].voiceUnavailable;
      setMessages((x) => [...x, { who: 'bot', text: note, time: now() }]);
    }
  };

  const endVoice = () => {
    const c = voiceRef.current;
    voiceRef.current = null;
    setVoiceState('idle');
    if (c) c.endSession().catch(() => {});
  };

  const onSubmit = (e) => { e.preventDefault(); sendText(input); };
  const started = messages.length > 0 || typing;
  const onCall = voiceState !== 'idle';

  return (
    <div className="chat-wrap" data-screen-label="Consultation chat">
      <div className="chat-bar">
        <div className="who">
          <span className="mk">{NZ_MARK}</span>
          <div>
            <div className="nm">NAZARBAN</div>
            <div className="sb">{t.consultant}</div>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <button className="chat-propbtn" onClick={() => setShowProp(true)}>{I.doc2} {t.getProposal}</button>
          <span className="chat-status"><span className="dot"></span>{t.online}</span>
        </div>
      </div>

      <div className="chat-scroll" ref={scrollRef}>
        {!started && (
          <div className="chat-welcome">
            <span className="chat-seal"><span className="ring"></span>{NZ_MARK}</span>
            <span className="eyebrow center">{t.welcomeEyebrow}</span>
            <h2>{t.welcomeH2}</h2>
            <p>{t.welcomeP}</p>
            <span className="chat-rule"></span>
            <div className="chat-chips">
              {t.prompts.map((label, idx) => (
                <button className="chat-chip" key={idx} onClick={() => sendText(label)}>
                  <span className="ci">{PROMPT_ICONS[idx]}</span>
                  {label}
                  <span className="ck">{I.arrow}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {messages.map((m, i) => (
          <div className={'chat-msg ' + m.who} key={i}>
            <span className="chat-av">{m.who === 'bot' ? NZ_MARK : 'YOU'}</span>
            {m.kind === 'whatsapp' ? <WhatsCard href={m.data.href} t={t} />
              : m.kind === 'products' ? <ProductsCard items={m.data.products} t={t} />
              : m.kind === 'benchmark' ? <BenchCard rows={m.data.rows} t={t} />
              : <div className="chat-bubble">{m.text}</div>}
          </div>
        ))}

        {typing && (
          <div className="chat-msg bot">
            <span className="chat-av">{NZ_MARK}</span>
            <div className="chat-typing"><i></i><i></i><i></i></div>
          </div>
        )}
      </div>

      {showProp && <ProposalPopup onClose={() => setShowProp(false)} getConversation={() => convo.current} hasConversation={started} initialEmail={propEmail} />}

      <div className="chat-dock">
        {onCall ? (
          <div className={'chat-inputwrap chat-callbar ' + (voiceState === 'live' ? voiceMode : 'connecting')}>
            <span className="chat-call-dot" aria-hidden="true"></span>
            <span className="chat-call-status" role="status">
              {voiceState === 'connecting' ? t.voiceConnecting : (voiceMode === 'speaking' ? t.voiceSpeaking : t.voiceListening)}
            </span>
            <button className="chat-call-end" type="button" onClick={endVoice}>
              {I.hangup} {t.voiceEnd}
            </button>
          </div>
        ) : (
          <form className="chat-inputwrap" onSubmit={onSubmit}>
            <input
              ref={inputRef}
              className="chat-input"
              value={input}
              placeholder={t.inputPh}
              onChange={(e) => setInput(e.target.value)}
            />
            {voiceCfg && (
              <button className="chat-mic" type="button" onClick={startVoice}
                aria-label={t.voiceStart} title={t.voiceStart}>
                {I.mic}
              </button>
            )}
            <button className={'chat-send' + (flew ? ' flew' : '')} type="submit"
              aria-label="Send" disabled={!input.trim() || typing}>
              {I.send}
            </button>
          </form>
        )}
        <div className="chat-foot">
          <a href="mailto:info@nazarbanai.com">{I.mail} info@nazarbanai.com</a>
          <a href={'https://wa.me/' + (lang === 'fa' ? WHATSAPP_NUMBER_FA : WHATSAPP_NUMBER)} target="_blank" rel="noopener">{I.phone} WhatsApp</a>
        </div>
      </div>
    </div>
  );
}

window.AtelierChat = AtelierChat;

// Mount. The script tags sit at the end of <body>, so the root node exists.
const chatRoot = document.getElementById('chat-root');
if (chatRoot) ReactDOM.createRoot(chatRoot).render(<AtelierChat />);
